import React from 'react';
import s from './CreateInvoicePopup.module.css';
import addressStyle from '../../Cart/Cart.module.css';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import {Field, useFormikContext} from 'formik';
import {useTranslation} from 'react-i18next';
import {ProductInDepotType} from '../../../types/ProductSliceTypes';
import {CreateInvoiceType} from '../../../types/TypesStore';
import ChangeContactSelector from '../../../Components/CreateAndEditOrderComponents/ChangeContactSelector/ChangeContactSelector';
import DeliveryTypeSelector from '../../../Components/DeliverySelector/DeliveryTypeSelector/DeliveryTypeSelector';
import DeliveryAddressesSelector from '../../../Components/DeliverySelector/DeliveryAdressesSelector/DeliveryAddressesSelector';
import CreatePopupBase from '../../../Components/CreatePopupBase/CreatePopupBase';

type Props = {
	close: () => void;
	prepareProducts: ProductInDepotType[];
	changeProductCallback: (
		id: string,
		action: '+' | '-' | 'manual' | 'remove',
		value?: number,
	) => void;
};

const CreateInvoicePopup: React.FC<Props> = ({
	close,
	prepareProducts,
	changeProductCallback,
}) => {
	const {t} = useTranslation();
	const {handleSubmit, errors, touched} = useFormikContext<CreateInvoiceType>();

	return (
		<CreatePopupBase
			close={close}
			prepareProducts={prepareProducts}
			changeProductCallback={changeProductCallback}
		>
			<div className={addressStyle.changeAdresInfo}>
				{t('Оберіть тип доставки')}
			</div>
			<DeliveryTypeSelector />
			{errors.service_type && (
				<div className={s.errorMessage}>{errors.service_type}</div>
			)}
			<DeliveryAddressesSelector />
			{errors.address_id && (
				<div className={s.errorMessage}>{errors.address_id}</div>
			)}
			<ChangeContactSelector />
			{errors.contact_id && touched.contact_id && (
				<div className={s.errorMessage}>{errors.contact_id}</div>
			)}
			<div className={s.addComment}>
				<div className={s.commentTitle}>{t('Додайте коментар')}</div>
				<Field as={'textarea'} name="comment" placeholder={t('Коментар')} />
				{errors.comment && touched.comment && (
					<div className={s.errorMessage}>{errors.comment}</div>
				)}
			</div>

			<div className={s.saveButtonWrapper}>
				<LightGreenButton
					type={'button'}
					text={t('Зберегти накладну')}
					onClick={handleSubmit}
				/>
			</div>
		</CreatePopupBase>
	);
};

export default CreateInvoicePopup;
